module.exports = __webpack_public_path__ + "img/1440.b0941c20.jpg";